import { Button } from "components/DesignSystem/Button/Button";
import { useModal } from "hooks/useModal";
import { CallSummaryViewModal } from "./CallSummaryViewModal";

export const CallSummaryCardLink = ({
  summary,
}: {
  summary?: string | null;
}) => {
  const modal = useModal();

  if (!summary) return null;

  return (
    <div className="t-mt-2">
      <Button type="button" customType="link" size="small" onClick={modal.open}>
        View AI call summary
      </Button>
      <CallSummaryViewModal
        isOpen={modal.isOpen}
        close={modal.close}
        summary={summary}
      />
    </div>
  );
};
